import { render, staticRenderFns } from "./CompanyEmployees.vue?vue&type=template&id=a8f5b0f6&scoped=true"
import script from "./CompanyEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyEmployees.vue?vue&type=script&lang=js"
import style0 from "./CompanyEmployees.vue?vue&type=style&index=0&id=a8f5b0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f5b0f6",
  null
  
)

export default component.exports